import React, { useEffect, useState } from "react";
import "./styles/Header.scss";
import { ReactComponent as Logo } from "../assets/logo.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { menuList } from "../utils/menu";
import { MoveToTop } from "../hooks/MoveToTop";
import { useLangNavigate } from "../hooks/useLangNavigate";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const langNavigate = useLangNavigate();
  const { lang } = useParams();
  const location = useLocation();
  const [inversion, setInversion] = useState(false);
  const [scrollDir, setScrollDir] = useState("up");
  const [hamburger, setHamburger] = useState(false);
  const [drop, setDrop] = useState<boolean[]>(menuList.filter((menu) => true).map(() => false));

  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.scrollY;
    let ticking = false;
    const updateScrollDir = () => {
      const scrollY = window.scrollY;
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? "down" : "up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollDir]);
  useEffect(() => {
    if (location.pathname === "/news") setInversion(true);
    else setInversion(false);
    MoveToTop();
  }, [location]);

  // useEffect(() => {
  //   const array = [];
  //   for (let i = 0; menuList.length > i; i++) {
  //     if (menuList[i].titleLink === "") array.push(false);
  //   }
  //   setDrop(array);
  // }, [menuList]);

  const handleHamburger = () => {
    setHamburger(!hamburger);
  };
  const handleMobileMenu = (title: string) => {
    const index = menuList.findIndex((menu: { title: string; list: { name: string; link: string }[] }) => {
      return menu.title === title;
    });
    const newDrop = [...drop];
    newDrop[index] = !newDrop[index];
    setDrop(newDrop);
  };
  // const openPdf = () => {
  //   window.open("/2024_Architeco Group PR_GO_Eng2.pdf", "_blank");
  // };
  const changLang = () => {
    if (!lang) return;
    const newLang = lang === "ko" ? "en" : "ko";
    const segments = location.pathname.split("/");
    // ["", "ko", "news", ...]
    segments[1] = newLang;
    navigate(segments.join("/"), { replace: true });
  };
  const clickHome = () => {
    langNavigate("/");
  };
  return (
    <>
      <div id="header_wrap">
        <div className="d_wrap" style={{ height: 80, top: `${scrollDir === "up" ? "0px" : "-80px"}` }}>
          <div className={`header ${inversion ? "inversion" : ""}`}>
            <div className="logo_wrap" onClick={clickHome}>
              <Logo className="logo" />
            </div>
            <div className="nav_wrap">
              <ul className="menu">
                {menuList.map((menu: { title: string; list: { name: string; link: string }[] }, index: number) => {
                  return <li key={`${menu.title}_${index}`}>{t(menu.title)}</li>;
                })}
              </ul>
              <button onClick={changLang}>
                <div className="img_box">
                  <img src={`/imgs/${lang === "ko" ? "en" : "ko"}.png`} alt="lang" />
                </div>
                {lang === "ko" ? "ENG" : "KOR"}
              </button>
            </div>
          </div>
          <div className="child_menu_wrap">
            {menuList.map((menu: { title: string; list: { name: string; link: string }[] }, index: number) => {
              return menu.list.length > 0 ? (
                <div className="child_menu" key={`${menu.title}_${index}`}>
                  <div className="name">{t(menu.title)}</div>
                  <ul>
                    {menu.list.map((li: { name: string }, index2: number) => {
                      return (
                        <li key={`${li.name}_${index2}`}>
                          <span
                            onClick={() => {
                              langNavigate(menuList[index].list[index2].link);
                            }}
                          >
                            {t(li.name)}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : null;
            })}
          </div>
        </div>
        <div className="m_wrap" style={{ height: 44, top: `${hamburger ? "0px" : scrollDir === "up" ? "0px" : "-44px"}` }}>
          <div className="m_header">
            <div className="logo_wrap" onClick={clickHome}>
              <Logo className="logo" />
            </div>
            <div className="ham_wrap" onClick={handleHamburger}>
              {hamburger ? <img src="/imgs/x.png" alt="x" /> : <img src="/imgs/hamburger.png" alt="hamubrger" />}
            </div>
          </div>
          {hamburger ? (
            <>
              <div className="m_menu_wrap">
                {menuList.map((menu: { title: string; list: { name: string; link: string }[] }, index: number) => {
                  return (
                    <ul key={`${menu.title}_${index}`}>
                      {
                        <>
                          <div
                            className="title"
                            onClick={() => {
                              handleMobileMenu(menu.title);
                            }}
                          >
                            <div className="text">{t(menu.title)}</div>
                            <div className={`btn${drop[index] ? " ative" : ""}`}>
                              <img src="/imgs/arrow_type_04.png" alt="arrow" />
                            </div>
                          </div>
                          {drop[index] ? (
                            <div className={`drop_wrap d_ative`}>
                              {menu.list.map((li: { name: string; link: string }, index2: number) => {
                                return (
                                  <li
                                    key={`${li.name}_${index2}`}
                                    onClick={() => {
                                      langNavigate(menuList[index].list[index2].link);
                                      setHamburger(false);
                                    }}
                                  >
                                    {t(li.name)}
                                  </li>
                                );
                              })}
                            </div>
                          ) : null}
                        </>
                      }
                    </ul>
                  );
                })}
                <button onClick={changLang}>
                  <div className="img_box">
                    <img src={`/imgs/${lang === "ko" ? "en" : "ko"}.png`} alt="lang" />
                  </div>
                  {lang === "ko" ? "ENG" : "KOR"}
                </button>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Header;
